import React from "react"

export const DollarSign = ({ height = 12, width = 12, stroke = "#05A44F", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_5691_39639)">
      <path d="M5.87402 0.489258V11.2583" stroke={stroke} strokeWidth="1.10138" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.32104 2.44727H4.64978C4.1954 2.44727 3.75962 2.62777 3.43832 2.94907C3.11703 3.27037 2.93652 3.70614 2.93652 4.16052C2.93652 4.61491 3.11703 5.05068 3.43832 5.37198C3.75962 5.69328 4.1954 5.87378 4.64978 5.87378H7.09729C7.55167 5.87378 7.98745 6.05428 8.30875 6.37558C8.63004 6.69688 8.81055 7.13265 8.81055 7.58704C8.81055 8.04142 8.63004 8.47719 8.30875 8.79849C7.98745 9.11979 7.55167 9.30029 7.09729 9.30029H2.93652" stroke={stroke} strokeWidth="1.10138" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5691_39639">
        <rect width="11.748" height="11.748" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
